export enum CommonHttpHeaders {
  XCorrelationId = 'X-Correlation-Id',
  XRequestTimeout = 'X-Request-Timeout',
  XSessionId = 'X-Session-Id'
}
